/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function () {
  'use strict';

  app.helpers.RedirectHelper = {
    CHECKOUT_URL: '/checkout/',

    /**
     * Редирект на страницу заказа
     * @param {Object} [options] Опции (is_remote=true - заказ с удаленного склада)
     * @returns {string} Адрес редиректа
     */
    goToCheckout: function (options) {
      var urlHelper = app.helpers.UrlHelper;
      var checkoutUrl = app.entryScriptName + this.CHECKOUT_URL;
      var checkoutParam = {};
      var urlParams = urlHelper.getUrlParameters();

      if (options) {
        if (options.is_remote) {
          checkoutParam = { remote_order: 1 };
        }
        if (options.is_fast_delivery) {
          checkoutParam = { fast_delivery: 1 };
        }
      }
      urlParams = _.extend(urlParams, checkoutParam);
      checkoutUrl += _.keys(urlParams).length
        ? '?' + urlHelper.getParamString(urlParams)
        : '';
      this._redirectTo(checkoutUrl);
      return checkoutUrl;
    },

    /**
     * Функция для редиректа
     * Вынесена отдельно для возможности тестирования goToCheckout()
     * @param {String} url Адрес для редиректа
     * @private
     */
    _redirectTo: function (url) {
      location.href = url;
    },

    /**
     * Редирект на заданную страницу
     * @param {String} path
     */
    locationAssign: function (path) {
      var origin = app.entryScriptName;
      if (_.indexOf(path.split(', '), '?') === 0) {
        origin = '';
      }
      window.location.assign(origin + path);
    },

    /**
     *  Переход на страницу регистрации
     *  @param {String} params Строка с параметрами
     */
    goToAuth: function (params) {
      if (typeof(params) !== 'string') {
        params = '';
      }
      this.locationAssign('/auth/' + params);
    },

    /**
     * Редирект с новыми параметрами
     * @param {Object} params - обьект с параметрами
     */
    redirectWithNewParams: function (params) {
      var urlParams = _.extend(app.helpers.UrlHelper.getUrlParameters(), params),
        url = app.helpers.UrlHelper.to(app.helpers.UrlHelper.getPathname(), [], urlParams);
      if (window.location.hash.length) {
        url += window.location.hash;
      }
      app.helpers.RedirectHelper.locationAssign(url);
    },
  };

})();

}.call(window));